module.exports = __webpack_public_path__ + "img/edit.0b3ec587.svg";